import Layout from 'components/layouts/main'
import Head from 'next/head'

export default function HowToUninstall() {
  return (
    <>
      <Head>
        <title key="title">TotalSystemCare | Uninstall Instructions</title>
      </Head>
      <Layout>
        <section className="hero-section">
          <div className="container policy-container">
            <div className="policy-wrapper">
              <div className="policy-title">
                <h1>Uninstall Our Software</h1>
              </div>
              <h3 className="text-title">Step 1. Navigate to Control Panel</h3>
              <p className="text">
                Begin by clicking the Start button in the bottom left of your
                screen, or the Windows key on your keyboard. Once the Start Menu
                is open, click Control Panel, or search for Control Panel in the
                search area to open it.
              </p>
              <h3 className="text-title">
                Step 2. Click on Uninstall Programs and Features.
              </h3>
              <p className="text">
                Within your Control Panel, click on Programs and Features.
              </p>
              <h3 className="text-title">
                Step 3. Find the software and Click Uninstall.
              </h3>
              <p className="text">
                Within the list of installed programs,
                locate&nbsp;TotalSystemCare&nbsp;and double click on it or right
                click and select Uninstall..
              </p>
              <h3 className="text-title">
                Step 4. Follow Onscreen Uninstall Instructions.
              </h3>
              <p className="text">
                Click Uninstall and follow the onscreen instructions to fully
                remove&nbsp;TotalSystemCare&nbsp;from your PC.
              </p>
              <p className="text"> Last Updated on April 18, 2022</p>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}
